// selectors.js
export const selectMatterFoldersData = (state) => state.getMatterFolders.data;
export const selectMatterFoldersLoading = (state) => state.getMatterFolders.loading;
export const selectMatterFoldersError = (state) => state.getMatterFolders.error;
